import { render, staticRenderFns } from "./WaterSupplied.vue?vue&type=template&id=0b5c7c34&scoped=true&"
import script from "./WaterSupplied.vue?vue&type=script&lang=js&"
export * from "./WaterSupplied.vue?vue&type=script&lang=js&"
import style0 from "./WaterSupplied.vue?vue&type=style&index=0&id=0b5c7c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c7c34",
  null
  
)

export default component.exports